<template>
  <div class="tx-blogs module-blogs-list">
    <div class="hero__element -wave--bottom-only" v-if="!loading && blogs.length > 0">
      <div class="background__background -bg-dark">
        <div class="-max-width-limited">
          <div class="blog__hero">
            <div class="hero__content">
              <div class="content__content col col__b2-4">
                <div class="content__division-date">
                  <div class="division__item"><span :style="`background-color: ${blogs[0].category.ciColor}`">{{ blogs[0].category.title }}</span></div>
                  <div class="date__item">
                    <span>/</span>{{ formatDate(blogs[0].date) }}
                  </div>
                </div>
                <div class="content__title">
                  <span class="heading beta">{{ blogs[0].title }}</span>
                </div>
                <div class="content__text" v-html="blogs[0].text"></div>
                <div class="content__link">
                  <a :href="blogs[0].link" class="icon-read-more-before">{{ $t('buttons.readMore') }}</a>
                </div>
              </div>
              <div class="content__image col col__b2-7">
                <div class="image__image">
                  <img :src="blogs[0].image.split('|')[0]" :alt="blogs[0].image.split('|')[1]" :title="blogs[0].image.split('|')[2]"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero__element -wave--bottom-only -loading" v-else>
      <div class="background__background -bg-dark">
        <div class="-max-width-limited">
          <div class="blog__hero">
            <div class="hero__content">
              <div class="content__content col col__b2-4">
                <div class="content__division-date"></div>
                <div class="content__title">
                  <div class="line line-one"></div>
                  <div class="line line-two"></div>
                  <div class="line line-three"></div>
                </div>
                <div class="content__text">
                  <div class="line line-one"></div>
                  <div class="line line-two"></div>
                  <div class="line line-three"></div>
                  <div class="line line-four"></div>
                </div>
                <div class="content__link"></div>
              </div>
              <div class="content__image col col__b2-7">
                <div class="image__image"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="categories__element" v-if="selectedCategoryUid === '0'">
      <div class="container__categories -max-width-limited">
        <a :href="category.blogOverviewPid" v-for="category in categoryObjects" :key="category.uid" :style="`border-color: ${category.ciColor}`" class="categories__category">
          <span :style="`color: ${category.ciColor}`">{{ category.title }}</span>
        </a>
      </div>
    </div>
    <div class="three-card__element" v-if="blogsFromTwoToFour.length > 0">
      <div class="section-row -padded-wide--mod-bottom-only">
        <div class="-max-width-limited">
          <div class="container__cards">
            <a :href="blog.link" class="cards__card col__b1-6 col__b2-4" v-for="blog in blogsFromTwoToFour" :key="blog.uid">
              <div class="card__content">
                <div class="content__image">
                  <img :src="blog.image.split('|')[0]" :alt="blog.image.split('|')[1]" :title="blog.image.split('|')[2]"/>
                </div>
                <div class="content__content">
                  <div class="content__division-date">
                    <div class="division__item"><span :style="`background-color: ${blog.category.ciColor}`">{{ blog.category.title }}</span></div>
                    <div class="date__item">
                      <span>/</span>{{ formatDate(blog.date) }}
                    </div>
                  </div>
                  <div class="content__title">
                    <span class="heading epsilon">{{ blog.title }}</span>
                  </div>
                  <div class="content__text" v-html="blog.text"></div>
                  <div class="content__link">
                    <span class="icon-read-more-before">{{ $t('buttons.readMore') }}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section-row -wave" v-if="blogs.length > 4">
      <div class="billboard__element" :style="`background-image: url('${blogs[4].image.split('|')[0]}')`">
        <div class="card__content -max-width-limited">
          <div class="content__division-date">
            <div class="division__item"><span :style="`background-color: ${blogs[4].category.ciColor}`">{{ blogs[4].category.title }}</span></div>
            <div class="date__item">
              <span>/</span>{{ formatDate(blogs[4].date) }}
            </div>
          </div>
          <div class="content__title">
            <span class="heading gamma">{{ blogs[4].title }}</span>
          </div>
          <div class="content__text" v-html="blogs[4].text"></div>
          <div class="content__button">
            <a :href="blogs[4].link" class="btn -btn-accent icon-read-more-before">{{ $t('buttons.readMore') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="list__element" v-if="blogsFromSixToEnd.length > 0">
      <div class="section-row">
        <div class="-max-width-limited">
          <div class="container__cards">
            <a :href="blog.link" class="cards__card col__b1-6 col__b2-4" v-for="(blog, index) in blogsFromSixToEnd" :key="blog.uid" v-show="index < visibleBlogs">
              <div class="card__content">
                <div class="content__image">
                  <img :src="blog.image.split('|')[0]" :alt="blog.image.split('|')[1]" :title="blog.image.split('|')[2]"/>
                </div>
                <div class="content__content">
                  <div class="content__division-date">
                    <div class="division__item"><span :style="`background-color: ${blog.category.ciColor}`">{{ blog.category.title }}</span></div>
                    <div class="date__item">
                      <span>/</span>{{ formatDate(blog.date) }}
                    </div>
                  </div>
                  <div class="content__title">
                    <span class="heading epsilon">{{ blog.title }}</span>
                  </div>
                  <div class="content__text" v-html="blog.text"></div>
                  <div class="content__link">
                    <span class="icon-read-more-before">{{ $t('buttons.readMore') }}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination__element" v-if="blogs.length >= shownElements">
      <div class="load-more__button" v-if="visibleBlogs < blogsFromSixToEnd.length">
        <div class="btn -btn-accent" @click="loadMore">{{ $t('buttons.loadMore') }}</div>
      </div>
      <div class="pagination__description">
        <div class="pagination__amount">
          <p><span>{{ shownElements }}</span> {{ $t('pagination.of') }} <span>{{ totalElements }}</span> {{ $t('pagination.loaded') }} </p>
        </div>
        <div class="pagination__bar">
          <div class="bar__progress" :style="`width: calc(100% / ${totalElements} * ${shownElements})`"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  name: 'App',
  components: {},
  data() {
    return {
      blogs: [],
      selectedCategoryUid: window.app.blog_list.category_uid,
      queryCategory: '',
      apiBase: window.app.blog_list.api_base,
      apiError: '',
      shownElements: 8,
      elementToLoad: 12,
      totalElements: null,
      visibleBlogs: 3,
      loading: false
    }
  },
  methods: {
    getAllBlogs()
    {
      this.loading = true
      if (this.selectedCategoryUid > 0) {
        this.queryCategory = `?category[equals]=${this.selectedCategoryUid}`
      }
      Axios.get(this.apiBase + 'blog-list/' + this.queryCategory)
        .then((response) => {
          this.blogs = response.data
          this.totalElements = this.blogs.length
          this.loading = false
        })
        .catch((error) => {
          this.apiError += error.message
        })
    },
    formatDate (date)
    {
      let currentDate = new Date(date * 1000)
      let curr_day = currentDate.getDate()
      let curr_month = currentDate.getMonth() + 1 // Add +1 for take the right month because the order is from 0 to 11
      let curr_year = currentDate.getFullYear()
      return ('0' + curr_day).slice(-2) + '.' + ('0' + curr_month).slice(-2) + '.' + curr_year
    },
    loadMore()
    {
      this.visibleBlogs += this.elementToLoad
      this.shownElements += this.elementToLoad
      if (this.shownElements > this.totalElements) {
        this.shownElements = this.totalElements
      }
    }
  },
  computed: {
    categoryObjects() {
      const categories = []
      this.blogs.forEach((item) => {
        const category = item.category
        const foundCategory = categories.find((c) => c.uid === category.uid)
        if (!foundCategory) {
          categories.push(category)
        }
      })
      return categories
    },
    blogsFromTwoToFour() {
      return this.blogs.slice(1, 4)
    },
    blogsFromSixToEnd() {
      return this.blogs.slice(5, this.blogs.length)
    }
  },
  mounted() {
    this.getAllBlogs()
  }
}
</script>
